webpackJsonp([11],{

/***/ 1084:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__social_ShareButton__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_universal_parallax_min__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_universal_parallax_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_universal_parallax_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__analytics_Tracking__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_MediaQueries__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_BrowserDetect__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PictureZoom__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_DomUtils__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__paid_content_PaidContent__ = __webpack_require__(1085);
// Import everything related to article page view


// We keep a local min version of this library because the maintainer didn't put any export








$(function () {
    __WEBPACK_IMPORTED_MODULE_3__analytics_Tracking__["a" /* default */].startArticleViewTracking();

    // For Luxtimes articles: set all article items as "fit"
    var luxtimesClass = $(".en");
    // EN articles have a different width/layout than other editions except for Storytelling articles
    var storytellingClass = $(".article-page-content--internal-storytelling"); // we want to keep the item--full for Storytelling intro

    if (storytellingClass.length <= 0 && luxtimesClass.length > 0) {
        $(".article-page-content .article-item--full, " + ".article-page-content .article-item--inline, " + ".article-page-content .article-item--inline-left," + ".article-page-content .article-item--inline-right ," + ".article-page-content .article-item--normal, " + ".article-page-content .article-item--normal--lg-up, " + ".article-page-content .context-box--right," + ".article-page-content .context-box--left").each(function () {
            var articleItem = $(this);
            var articleItemClasses = articleItem.attr("class").split(/\s+/);
            // if it's an inline-left or inline-right picture, we keep it as is. Otherwise, we set item as "fit"
            if (!(articleItemClasses.includes("article-picture") && (articleItemClasses.includes("article-item--inline-right") || articleItemClasses.includes("article-item--inline-left")))) {
                articleItem.removeClass("article-item--full " + "article-item--normal " + "article-item--inline " + "article-item--inline-right " + "article-item--inline-left " + "article-item--normal--lg-up ");
                articleItem.addClass("article-item--fit");
            }
        });
    }

    var initShareButtons = function initShareButtons(name, value) {
        var shareButtonClass = "share__content__item",
            shareButtonsClass = "share-buttons",
            articlePageContentClass = "article-page-content";
        __WEBPACK_IMPORTED_MODULE_1__social_ShareButton__["a" /* default */].init(articlePageContentClass);
        if (!name || !value) {
            __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__["a" /* default */].init(shareButtonsClass);
            __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__["a" /* default */].init(shareButtonClass);
        } else {
            __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__["a" /* default */].initWithParameter(shareButtonsClass, name, value);
            __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__["a" /* default */].initWithParameter(shareButtonClass, name, value);
        }
        __WEBPACK_IMPORTED_MODULE_0__social_ShareButtons__["a" /* default */].initScroll(shareButtonsClass);
    };

    if (!window.isPreview) {
        // Apply Medium.com zoom effect on pictures
        Object(__WEBPACK_IMPORTED_MODULE_6__PictureZoom__["a" /* default */])();
    }
    window.pym.autoInit();

    // Editor cm link hack
    var cmLink = $("#article-content").data("cm");
    if (cmLink) {
        $(document).on("dblclick", "#article-title", function (e) {
            if (e.shiftKey && e.altKey) {
                var win = window.open(cmLink, "_blank");
                win.focus();
            }
        });
    }

    // Picture gallery support for IE
    if (__WEBPACK_IMPORTED_MODULE_5__utils_BrowserDetect__["a" /* default */].isIe11orBelow()) {
        $(".picture-gallery--grid").addClass("u-hide");
        $(".picture-gallery-container").removeClass("u-hide");
    }

    // Before/after embeds
    Array.from(document.querySelectorAll(".before-after-embed")).forEach(function (beforeAfterEmbed) {
        var inkbox = beforeAfterEmbed.querySelector(".before-after-embed__after"),
            colorbox = beforeAfterEmbed.querySelector(".before-after-embed__before"),
            fillerImage = beforeAfterEmbed.querySelector(".before-after-embed__after__img");

        // juxtapose engine
        function trackLocation(e) {
            e.preventDefault();
            var rect = fillerImage.getBoundingClientRect();
            var mousepos = e.pageX;
            if (isNaN(mousepos)) {
                mousepos = event.targetTouches[0].pageX;
            }
            var position = (mousepos - rect.left) / fillerImage.offsetWidth * 100;
            if (position <= 100) {
                colorbox.style.width = position + "%";
            }
        }

        inkbox.addEventListener("mousemove", trackLocation, false);
        inkbox.addEventListener("touchstart", trackLocation, false);
        inkbox.addEventListener("touchmove", trackLocation, false);
    });

    // parallax effect for Windowed and Fill Screen embed pics
    var parallaxPics = document.querySelectorAll(".parallax");
    if (parallaxPics.length > 0) {
        parallaxPics.forEach(function (picture) {
            // If available, apply mobile cropping
            var parallaxImgMobile = picture.getAttribute("data-parallax-image-mobile");
            if (parallaxImgMobile && __WEBPACK_IMPORTED_MODULE_4__utils_MediaQueries__["a" /* default */].isMobile()) {
                picture.setAttribute("data-parallax-image", parallaxImgMobile);
            }
        });
        new window.universalParallax().init({
            speed: 6.0
        });
    }

    // add video theme
    var specialTheme = __WEBPACK_IMPORTED_MODULE_7__utils_DomUtils__["a" /* getMetadata */]("specialTheme");
    if (specialTheme) {
        document.body.classList.add(specialTheme);
    }

    var stIframe = document.getElementById("strytl");
    if (stIframe) {
        //storytile inbound
        window.addEventListener("message", function (e) {
            if (e.origin === "https://e.stry.tl") {
                var msg = {};
                try {
                    msg = JSON.parse(e.data);
                } catch (err) {
                    console.log("error parsing strytl event");
                }

                if (msg.initial) {
                    if (msg.event === "update-values" && msg.data && msg.data.nextPage) {
                        var currentPage = Number.parseInt(msg.data.nextPage.replace("-", "")) + 1;
                        initShareButtons("strytlpage", currentPage);
                    } else {
                        initShareButtons();
                    }
                }
            }
        });
    } else if (!window.isPreview) {
        initShareButtons();
    }
});

/***/ }),

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__analytics_Tracking__ = __webpack_require__(69);


$(function () {
    function addEventOnBtn(btnName, eventCategoryEdition, url) {
        var btnOverlay = document.getElementById("hpwOverlay-" + btnName + "Btn");
        var btnInBody = document.getElementById("hpwInBody-" + btnName + "Btn");

        [btnOverlay, btnInBody].forEach(function (b) {
            b && b.addEventListener("click", function (event) {
                if (url) {
                    event.preventDefault();
                }

                __WEBPACK_IMPORTED_MODULE_0__analytics_Tracking__["a" /* default */].track("action." + event.target.id, window.hardPaywallTrackingData);

                var boxType = b.id.indexOf("Overlay") !== -1 ? "Overlay" : "Box";
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'UniversalEvent',
                    'eventCategory': eventCategoryEdition + " | " + boxType,
                    'eventAction': 'Click',
                    'eventLabel': btnName
                });

                if (url) {
                    window.location.href = $(b).attr("href") || url;
                }
            });
        });
    }

    if (window.hardPaywallTrackingData) {
        var contentEditionId = window.hardPaywallTrackingData.editionId;
        var eventCategoryEdition = "Wort+";

        if (contentEditionId === "en") {
            eventCategoryEdition = "LT+";

            addEventOnBtn("month", eventCategoryEdition, "/monthly");
            addEventOnBtn("quarterly", eventCategoryEdition, "/quarterly");
            addEventOnBtn("year", eventCategoryEdition, "/yearly");
        } else if (contentEditionId === "de") {
            addEventOnBtn("offers", eventCategoryEdition, "/de/special-offer");
        }
        addEventOnBtn("login", eventCategoryEdition);
    }
});

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = svgIcon;
/* harmony export (immutable) */ __webpack_exports__["a"] = getMetadata;

/**
 * Creates an svg DOM element that is a reference to the svg icon in the svg definition
 */
function svgIcon(id, className) {

    var svgNs = 'http://www.w3.org/2000/svg';
    var xlinkNs = 'http://www.w3.org/1999/xlink';

    var svg = document.createElementNS(svgNs, 'svg');

    if (className) {
        svg.setAttribute('class', className);
    }

    var use = document.createElementNS(svgNs, 'use');
    use.setAttributeNS(xlinkNs, 'href', '#' + id);

    svg.appendChild(use);

    return svg;
}

function getMetadata(name) {
    var metadata = document.querySelector('meta[name=\'' + name + '\'], meta[itemprop=\'' + name + '\']');

    return metadata ? metadata.getAttribute('content') : undefined;
}

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var windowHeight = window.innerHeight,
    windowHeightExtra = 0;var safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    mobile = /Mobi/.test(navigator.userAgent);if (safari && !mobile) {
    windowHeightExtra = window.outerHeight - window.innerHeight;
}
if (mobile) {
    windowHeight = window.screen.availHeight;windowHeightExtra = (window.screen.availHeight - window.innerHeight) / 2;
}
function positionParallax(container, speed, parallax, elem) {
    var bgScroll = container.top / speed - windowHeightExtra;parallax[elem].style.top = bgScroll + 'px';
}
function animateParallax(parallax, speed) {
    for (var i = 0; parallax.length > i; i++) {
        var container = parallax[i].parentElement.parentElement.getBoundingClientRect();if (container.top + container.height >= 0 && container.top <= windowHeight) {
            positionParallax(container, speed, parallax, i);
        }
    }
}
function calculateHeight(parallax, speed) {
    for (var i = 0; parallax.length > i; i++) {
        var container = parallax[i].parentElement.parentElement.getBoundingClientRect();var elemOffsetTop = (windowHeight - container.height) / 2;var bgHeight = container.height + (elemOffsetTop - elemOffsetTop / speed) * 2;parallax[i].style.height = bgHeight + windowHeightExtra * 2 + 'px';positionParallax(container, speed, parallax, i);
    }
}
var universalParallax = function universalParallax() {
    var up = function up(parallax, speed, scrollElement) {
        if (speed < 1) {
            speed = 1;
        }
        calculateHeight(parallax, speed);if (!mobile) {
            scrollElement.addEventListener("resize", function () {
                windowHeight = window.innerHeight;calculateHeight(parallax, speed);
            });
        }
        scrollElement.addEventListener("scroll", function () {
            animateParallax(parallax, speed);
        });
    };this.init = function (param) {
        if (typeof param === 'undefined') {
            param = {};
        }
        param = { speed: typeof param.speed !== 'undefined' ? param.speed : 1.5, scrollElement: typeof param.scrollElement !== 'undefined' ? param.scrollElement : window, className: typeof param.className !== 'undefined' ? param.className : 'parallax' };var parallax = document.getElementsByClassName(param.className);for (var i = 0; parallax.length > i; i++) {
            var wrapper = document.createElement('div');parallax[i].parentNode.insertBefore(wrapper, parallax[i]);wrapper.appendChild(parallax[i]);var parallaxContainer = parallax[i].parentElement;parallaxContainer.className += 'parallax__container';if (window.getComputedStyle(parallaxContainer.parentElement, null).getPropertyValue('position') !== 'relative') {
                parallaxContainer.parentElement.style.position = 'relative';
            }
            var imgData = parallax[i].getAttribute('data-parallax-image');if (typeof imgData !== 'undefined') {
                parallax[i].style.backgroundImage = 'url(' + imgData + ')';if (parallax[i].classList.length === 1 && parallax[i].classList[0] === 'parallax') {
                    Object.assign(parallax[i].style, { 'background-repeat': 'no-repeat', 'background-position': 'center', 'background-size': 'cover' });
                }
            }
        };up(parallax, param.speed, param.scrollElement);
    };
};window.universalParallax = universalParallax;

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_MediaQueries__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_BrowserDetect__ = __webpack_require__(81);

/**
 * Share button displayed on the article page.
 * Since it's really tied to Bottom bar, logic about showing/hiding button is done in NavbarScroll.js
 */




var $share = $(".share"),
    trigger = "[data-share-menu]",
    openingShareClass = "share--opening",
    openShareClass = "share--open",
    visibleShareClass = "share--visible",
    pushToFrontShareClass = "share--push-to-front";

function getOpenGraphData(property) {
    var metadata = document.querySelector("meta[property='" + property + "']");

    return metadata ? metadata.getAttribute('content') : "";
}

function handleScroll(articlePage) {
    // We want to handle scroll for sharing button only on mobile / tablet
    if (__WEBPACK_IMPORTED_MODULE_1__utils_MediaQueries__["a" /* default */].isLgUp()) {
        return;
    }

    var scrollY = $(window).scrollTop();
    // Hide share button when scroll reaches article page's bottom
    if (scrollY >= articlePage.height() - articlePage.position().top) {
        $share.removeClass("share--visible");
    } else if (scrollY > 300 && scrollY <= articlePage.height() - articlePage.position().top) {
        $share.addClass("share--visible");
    }
}

function initScroll(articlePage) {
    var throttledHandleScroll = function throttledHandleScroll() {
        return requestAnimationFrame(function () {
            return handleScroll(articlePage);
        });
    };
    $(window).scroll(__WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default()(throttledHandleScroll, 100));
}

function initNativeShare() {
    $(trigger).click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        navigator.share({
            title: getOpenGraphData("og:title"),
            text: getOpenGraphData("og:description"),
            url: getOpenGraphData("og:url")
        }).then(function () {
            return console.log('Successful share');
        }).catch(function (error) {
            return console.log('Error sharing', error);
        });

        return false;
    });
}

function initSpecialShare() {

    var duration = 150,
        longDuration = 350;

    $(trigger).click(function (e) {

        var shouldPreventEvent = $(this).attr('href') === '#';

        if (shouldPreventEvent) {
            e.preventDefault();
        }

        // On desktop, sticky share button is hidden by default, so we display only when overlay is here
        if (__WEBPACK_IMPORTED_MODULE_1__utils_MediaQueries__["a" /* default */].isLgUp()) {
            $share.toggleClass("hide-for-large-up");
            $share.toggleClass(visibleShareClass);
        }
        // Change share button icon to close button + avoid scroll on the whole body
        if ($share.hasClass(openingShareClass)) {
            $share.removeClass(openShareClass);
            $("body, html").removeClass("u-disable-scroll");
            window.setTimeout(function () {
                $share.removeClass(pushToFrontShareClass);
            }, longDuration);
            window.setTimeout(function () {
                $share.removeClass(openingShareClass);
            }, duration);
        }
        // Reset share button icon
        else {
                $share.addClass(openingShareClass);
                $share.addClass(pushToFrontShareClass);
                $("body, html").addClass("u-disable-scroll");
                window.setTimeout(function () {
                    $share.addClass(openShareClass);
                    $share.addClass(visibleShareClass);
                }, duration);
            }

        if (shouldPreventEvent) {
            return false;
        }
    });
}

/* harmony default export */ __webpack_exports__["a"] = ({
    init: function init(articlePage) {
        if (articlePage) {
            initScroll($("." + articlePage));
        }

        var iOsShareButton = $('.share__button__ios-share'),
            androidShareButton = $('.share__button__android-share');

        if (__WEBPACK_IMPORTED_MODULE_2__utils_BrowserDetect__["a" /* default */].isIOS()) {
            iOsShareButton.removeClass("u-hide");
        } else {
            androidShareButton.removeClass("u-hide");
        }

        // If browser support native share, enable it, otherwise display a custom share interface
        if (navigator.share) {
            initNativeShare();
        } else {
            initSpecialShare();
        }
    }
});

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_medium_zoom__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_MediaQueries__ = __webpack_require__(46);



var initPictureZoom = function initPictureZoom() {
    var backgroundColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "white";

    if (__WEBPACK_IMPORTED_MODULE_1__utils_MediaQueries__["a" /* default */].isMobile()) return;

    var pictures = document.querySelectorAll(".article-picture:not(.article-item--full) img:not(.medium-zoom-image)");

    Object(__WEBPACK_IMPORTED_MODULE_0_medium_zoom__["a" /* default */])(pictures, {
        background: backgroundColor
    });
};

/* harmony default export */ __webpack_exports__["a"] = (initPictureZoom);

/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*! medium-zoom 1.0.4 | MIT License | https://github.com/francoischalifour/medium-zoom */var _extends=Object.assign||function(a){for(var b,c=1;c<arguments.length;c++)for(var d in b=arguments[c],b)Object.prototype.hasOwnProperty.call(b,d)&&(a[d]=b[d]);return a},isSupported=function(a){return'IMG'===a.tagName},isNodeList=function(a){return NodeList.prototype.isPrototypeOf(a)},isNode=function(a){return a&&1===a.nodeType},isSvg=function(a){var b=a.currentSrc||a.src;return'.svg'===b.substr(-4).toLowerCase()},getImagesFromSelector=function(a){try{return Array.isArray(a)?a.filter(isSupported):isNodeList(a)?[].slice.call(a).filter(isSupported):isNode(a)?[a].filter(isSupported):'string'==typeof a?[].slice.call(document.querySelectorAll(a)).filter(isSupported):[]}catch(a){throw new TypeError('The provided selector is invalid.\nExpects a CSS selector, a Node element, a NodeList or an array.\nSee: https://github.com/francoischalifour/medium-zoom')}},createOverlay=function(a){var b=document.createElement('div');return b.classList.add('medium-zoom-overlay'),b.style.background=a,b},cloneTarget=function(a){var b=a.getBoundingClientRect(),c=b.top,d=b.left,e=b.width,f=b.height,g=a.cloneNode(),h=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0,i=window.pageXOffset||document.documentElement.scrollLeft||document.body.scrollLeft||0;return g.removeAttribute('id'),g.style.position='absolute',g.style.top=c+h+'px',g.style.left=d+i+'px',g.style.width=e+'px',g.style.height=f+'px',g.style.transform='',g},createCustomEvent=function(a,b){var c=_extends({bubbles:!1,cancelable:!1,detail:void 0},b);if('function'==typeof window.CustomEvent)return new CustomEvent(a,c);var d=document.createEvent('CustomEvent');return d.initCustomEvent(a,c.bubbles,c.cancelable,c.detail),d},mediumZoom=function a(b){var c=1<arguments.length&&arguments[1]!==void 0?arguments[1]:{},d=window.Promise||function(a){function b(){}a(b,b)},e=function(a){var b=a.target;return b===x?void n():void(-1===r.indexOf(b)||o({target:b}))},f=function(){if(!t&&w.original){var a=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0;Math.abs(u-a)>v.scrollOffset&&setTimeout(n,150)}},g=function(){var a=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},b=a;if(a.background&&(x.style.background=a.background),a.container&&a.container instanceof Object&&(b.container=_extends({},v.container,a.container)),a.template){var c=isNode(a.template)?a.template:document.querySelector(a.template);b.template=c}return v=_extends({},v,b),r.forEach(function(a){a.dispatchEvent(createCustomEvent('medium-zoom:update',{detail:{zoom:y}}))}),y},h=function(){var b=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{};return a(_extends({},v,b))},i=function(){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];var d=b.reduce(function(a,b){return[].concat(a,getImagesFromSelector(b))},[]);return d.filter(function(a){return-1===r.indexOf(a)}).forEach(function(a){r.push(a),a.classList.add('medium-zoom-image')}),s.forEach(function(a){var b=a.type,c=a.listener,e=a.options;d.forEach(function(a){a.addEventListener(b,c,e)})}),y},j=function(){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];w.zoomed&&n();var d=0<b.length?b.reduce(function(a,b){return[].concat(a,getImagesFromSelector(b))},[]):r;return d.forEach(function(a){a.classList.remove('medium-zoom-image'),a.dispatchEvent(createCustomEvent('medium-zoom:detach',{detail:{zoom:y}}))}),r=r.filter(function(a){return-1===d.indexOf(a)}),y},k=function(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};return r.forEach(function(d){d.addEventListener('medium-zoom:'+a,b,c)}),s.push({type:'medium-zoom:'+a,listener:b,options:c}),y},l=function(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{};return r.forEach(function(d){d.removeEventListener('medium-zoom:'+a,b,c)}),s=s.filter(function(c){return c.type!=='medium-zoom:'+a||c.listener.toString()!==b.toString()}),y},m=function(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{},b=a.target,c=function(){var a=Math.min,b={width:document.documentElement.clientWidth,height:document.documentElement.clientHeight,left:0,top:0,right:0,bottom:0},c=void 0,d=void 0;if(v.container)if(v.container instanceof Object)b=_extends({},b,v.container),c=b.width-b.left-b.right-2*v.margin,d=b.height-b.top-b.bottom-2*v.margin;else{var e=isNode(v.container)?v.container:document.querySelector(v.container),f=e.getBoundingClientRect(),g=f.width,h=f.height,i=f.left,j=f.top;b=_extends({},b,{width:g,height:h,left:i,top:j})}c=c||b.width-2*v.margin,d=d||b.height-2*v.margin;var k=w.zoomedHd||w.original,l=isSvg(k)?c:k.naturalWidth||c,m=isSvg(k)?d:k.naturalHeight||d,n=k.getBoundingClientRect(),o=n.top,p=n.left,q=n.width,r=n.height,s=a(l,c)/q,t=a(m,d)/r,u=a(s,t),x=(-p+(c-q)/2+v.margin+b.left)/u,y=(-o+(d-r)/2+v.margin+b.top)/u,z='scale('+u+') translate3d('+x+'px, '+y+'px, 0)';w.zoomed.style.transform=z,w.zoomedHd&&(w.zoomedHd.style.transform=z)};return new d(function(a){if(b&&-1===r.indexOf(b))return void a(y);if(w.zoomed)return void a(y);if(b)w.original=b;else if(0<r.length){var d=r;w.original=d[0]}else return void a(y);if(w.original.dispatchEvent(createCustomEvent('medium-zoom:open',{detail:{zoom:y}})),u=window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0,t=!0,w.zoomed=cloneTarget(w.original),document.body.appendChild(x),v.template){var e=isNode(v.template)?v.template:document.querySelector(v.template);w.template=document.createElement('div'),w.template.appendChild(e.content.cloneNode(!0)),document.body.appendChild(w.template)}if(document.body.appendChild(w.zoomed),window.requestAnimationFrame(function(){document.body.classList.add('medium-zoom--opened')}),w.original.classList.add('medium-zoom-image--hidden'),w.zoomed.classList.add('medium-zoom-image--opened'),w.zoomed.addEventListener('click',n),w.zoomed.addEventListener('transitionend',function b(){t=!1,w.zoomed.removeEventListener('transitionend',b),w.original.dispatchEvent(createCustomEvent('medium-zoom:opened',{detail:{zoom:y}})),a(y)}),w.original.getAttribute('data-zoom-src')){w.zoomedHd=w.zoomed.cloneNode(),w.zoomedHd.removeAttribute('srcset'),w.zoomedHd.removeAttribute('sizes'),w.zoomedHd.src=w.zoomed.getAttribute('data-zoom-src'),w.zoomedHd.onerror=function(){clearInterval(f),console.warn('Unable to reach the zoom image target '+w.zoomedHd.src),w.zoomedHd=null,c()};var f=setInterval(function(){w.zoomedHd.complete&&(clearInterval(f),w.zoomedHd.classList.add('medium-zoom-image--opened'),w.zoomedHd.addEventListener('click',n),document.body.appendChild(w.zoomedHd),c())},10)}else if(w.original.hasAttribute('srcset')){w.zoomedHd=w.zoomed.cloneNode(),w.zoomedHd.removeAttribute('sizes');var g=w.zoomedHd.addEventListener('load',function(){w.zoomedHd.removeEventListener('load',g),w.zoomedHd.classList.add('medium-zoom-image--opened'),w.zoomedHd.addEventListener('click',n),document.body.appendChild(w.zoomedHd),c()})}else c()})},n=function(){return new d(function(a){if(t||!w.original)return void a(y);t=!0,document.body.classList.remove('medium-zoom--opened'),w.zoomed.style.transform='',w.zoomedHd&&(w.zoomedHd.style.transform=''),w.template&&(w.template.style.transition='opacity 150ms',w.template.style.opacity=0),w.original.dispatchEvent(createCustomEvent('medium-zoom:close',{detail:{zoom:y}})),w.zoomed.addEventListener('transitionend',function b(){w.original.classList.remove('medium-zoom-image--hidden'),document.body.removeChild(w.zoomed),w.zoomedHd&&document.body.removeChild(w.zoomedHd),document.body.removeChild(x),w.zoomed.classList.remove('medium-zoom-image--opened'),w.template&&document.body.removeChild(w.template),t=!1,w.zoomed.removeEventListener('transitionend',b),w.original.dispatchEvent(createCustomEvent('medium-zoom:closed',{detail:{zoom:y}})),w.original=null,w.zoomed=null,w.zoomedHd=null,w.template=null,a(y)})})},o=function(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{},b=a.target;return w.original?n():m({target:b})},p=function(){return v},q=function(){return r},r=[],s=[],t=!1,u=0,v=c,w={original:null,zoomed:null,zoomedHd:null,template:null};'[object Object]'===Object.prototype.toString.call(b)?v=b:(b||'string'==typeof b)&&i(b),v=_extends({margin:0,background:'#fff',scrollOffset:40,container:null,template:null},v);var x=createOverlay(v.background);document.addEventListener('click',e),document.addEventListener('keyup',function(a){27===(a.keyCode||a.which)&&n()}),document.addEventListener('scroll',f),window.addEventListener('resize',n);var y={open:m,close:n,toggle:o,update:g,clone:h,attach:i,detach:j,on:k,off:l,getOptions:p,getImages:q,getZoomedImage:function(){return w.original}};return y};function styleInject(a,b){void 0===b&&(b={});var c=b.insertAt;if(a&&'undefined'!=typeof document){var d=document.head||document.getElementsByTagName('head')[0],e=document.createElement('style');e.type='text/css','top'===c?d.firstChild?d.insertBefore(e,d.firstChild):d.appendChild(e):d.appendChild(e),e.styleSheet?e.styleSheet.cssText=a:e.appendChild(document.createTextNode(a))}}var css='.medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--opened .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s cubic-bezier(.2,0,.2,1)}.medium-zoom-image--hidden{visibility:hidden}.medium-zoom-image--opened{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}';styleInject('.medium-zoom-overlay{position:fixed;top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .3s;will-change:opacity}.medium-zoom--opened .medium-zoom-overlay{cursor:pointer;cursor:zoom-out;opacity:1}.medium-zoom-image{cursor:pointer;cursor:zoom-in;transition:transform .3s cubic-bezier(.2,0,.2,1)}.medium-zoom-image--hidden{visibility:hidden}.medium-zoom-image--opened{position:relative;cursor:pointer;cursor:zoom-out;will-change:transform}');/* harmony default export */ __webpack_exports__["a"] = (mediumZoom);


/***/ })

},[1084]);


// WEBPACK FOOTER //
// javascripts/articlePage.js